import { render, staticRenderFns } from "./drugbookEntries.vue?vue&type=template&id=2af4a44e&"
import script from "./drugbookEntries.vue?vue&type=script&lang=js&"
export * from "./drugbookEntries.vue?vue&type=script&lang=js&"
import style0 from "./drugbookEntries.vue?vue&type=style&index=0&id=2af4a44e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports